"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _without2 = _interopRequireDefault(require("lodash/without"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _TicketStatus = _interopRequireDefault(require("../TicketStatus"));
var _TicketFilterByClient = _interopRequireDefault(require("../TicketFilterByClient"));
var _TicketFilterByMailGroup = _interopRequireDefault(require("../TicketFilterByMailGroup"));
var _TicketFilterByManager = _interopRequireDefault(require("../TicketFilterByManager"));
var _TicketFilterByOrderStatus = _interopRequireDefault(require("../TicketFilterByOrderStatus"));
var _TicketFilterByTag = _interopRequireDefault(require("../TicketFilterByTag"));
var _TicketFilterByType = _interopRequireDefault(require("../TicketFilterByType"));
var _TicketFilterByDate = _interopRequireDefault(require("../TicketFilterByDate"));
var _TicketFilterByStatus = _interopRequireDefault(require("../TicketFilterByStatus"));
var _TicketNoOrderFilter = _interopRequireDefault(require("../TicketNoOrderFilter"));
var _iconsReact = require("../../../../icons-react");
var _userflow = require("../../../../utils/userflow");
var _excluded = ["clients", "managers", "statuses", "closedReasonStatuses", "tags", "types", "total", "mailGroups", "activeTicketsTab", "filters", "sort", "currentManager"],
  _excluded2 = ["editableFilters", "managers", "onClear", "onClose", "onFilter", "onClearFilter", "onCheckoutFilter", "onFilterByName", "onSubmit", "statuses", "closedReasonStatuses", "mailGroups", "tags", "types", "currentManager"],
  _excluded3 = ["onClear", "onSort", "sort", "onClickFilter", "onClickActual", "onClickPlanned", "activeTicketsTab", "total", "filters"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ticketFilterByClientDefault = _TicketFilterByClient["default"].defaultProps,
  ticketFilterByClientTypes = _TicketFilterByClient["default"].propTypes;
var clientsDefault = ticketFilterByClientDefault.clnts;
var clientsType = ticketFilterByClientTypes.clients,
  clientsValueType = ticketFilterByClientTypes.value;
var ticketFilterByManagerDefault = _TicketFilterByManager["default"].defaultProps,
  ticketFilterByManagerTypes = _TicketFilterByManager["default"].propTypes;
var managersDefault = ticketFilterByManagerDefault.managers;
var managersType = ticketFilterByManagerTypes.managers,
  managersValueType = ticketFilterByManagerTypes.value;
var ORDER_STATUSES = _TicketFilterByOrderStatus["default"].ORDER_STATUSES,
  ticketFilterByOrderStatusTypes = _TicketFilterByOrderStatus["default"].propTypes;
var orderStatusesValueType = ticketFilterByOrderStatusTypes.value;
var ticketFilterByTagDefault = _TicketFilterByTag["default"].defaultProps,
  ticketFilterByTagTypes = _TicketFilterByTag["default"].propTypes;
var tagsDefault = ticketFilterByTagDefault.tags;
var tagsType = ticketFilterByTagTypes.tags,
  tagsValueType = ticketFilterByTagTypes.value;
var ticketFilterByTypeDefaultProps = _TicketFilterByType["default"].defaultProps,
  ticketFilterByTypePropTypes = _TicketFilterByType["default"].propTypes;
var typesDefaultProp = ticketFilterByTypeDefaultProps.types;
var typesPropType = ticketFilterByTypePropTypes.types;
var PRIORITIES = _TicketStatus["default"].PRIORITIES;
var StyledCheckboxWrapper = _Checkbox["default"].StyledWrapper;
var ticketStatusPropTypes = _TicketStatus["default"].propTypes;
var ticketFilterByMailGroupDefaulProps = _TicketFilterByMailGroup["default"].defaultProps,
  ticketFilterByMailGroupPropTypes = _TicketFilterByMailGroup["default"].propTypes;
var mailGroupsDefault = ticketFilterByMailGroupDefaulProps.mailGroups;
var mailGroupsPropType = ticketFilterByMailGroupPropTypes.mailGroups,
  mailGroupsValueType = ticketFilterByMailGroupPropTypes.value;
var FILTER_NAMES = {
  CLIENT: 'client_id',
  DEPARTURE_DATE: 'departureDate',
  MAIL_GROUPS: 'mailGroups',
  MANAGERS: 'managers',
  ORDER_STATUSES: 'orderStatuses',
  STATUSES: 'statuses',
  TAGS: 'tags',
  TYPES: 'types',
  CLOSE_REASON_STATUSES: 'closeReasonStatuses',
  ORDERS: 'orders'
};
var FILTER_TABS = {
  ACTUAL: 'actual',
  PLANNED: 'planned'
};
var EDITABLE_FILTERS = [FILTER_NAMES.CLIENT, FILTER_NAMES.DEPARTURE_DATE, FILTER_NAMES.MAIL_GROUPS, FILTER_NAMES.MANAGERS, FILTER_NAMES.ORDER_STATUSES, FILTER_NAMES.STATUSES, FILTER_NAMES.TAGS, FILTER_NAMES.TYPES, FILTER_NAMES.CLOSE_REASON_STATUSES];
var ticketPluralize = ['тикет', 'тикета', 'тикетов'];
var filterPluralize = ['Фильтр', 'Фильтра', 'Фильтров'];
var TicketFilters = /*#__PURE__*/function (_React$Component) {
  function TicketFilters(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketFilters);
    _this = _callSuper(this, TicketFilters, [props]);
    _this.state = {
      isOpenFilters: false,
      editableFilters: (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, FILTER_TABS.ACTUAL, props.filters[FILTER_TABS.ACTUAL] || props.initialFilters[FILTER_TABS.ACTUAL]), FILTER_TABS.PLANNED, props.filters[FILTER_TABS.PLANNED] || props.initialFilters[FILTER_TABS.PLANNED])
    };
    _this.el = /*#__PURE__*/_react["default"].createRef();
    _this.handleClear = _this.handleClear.bind(_this);
    _this.handleClearEditableFilters = _this.handleClearEditableFilters.bind(_this);
    _this.handleClearEditableFilter = _this.handleClearEditableFilter.bind(_this);
    _this.handleFilterByName = _this.handleFilterByName.bind(_this);
    _this.handleFilter = _this.handleFilter.bind(_this);
    _this.handleCheckoutFilter = _this.handleCheckoutFilter.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleToggleFilters = _this.handleToggleFilters.bind(_this);
    _this.handleChangeTicketsTab = _this.handleChangeTicketsTab.bind(_this);
    _this.handleClickActualTab = _this.handleClickActualTab.bind(_this);
    _this.handleClickPlannedTab = _this.handleClickPlannedTab.bind(_this);
    _this.handleSort = _this.handleSort.bind(_this);
    _this.handleCloseFiltersModal = _this.handleCloseFiltersModal.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketFilters, _React$Component);
  return (0, _createClass2["default"])(TicketFilters, [{
    key: "handleClear",
    value: function handleClear(event) {
      var _this2 = this;
      event.preventDefault();
      event.stopPropagation();
      var _this$props = this.props,
        initialFilters = _this$props.initialFilters,
        onClear = _this$props.onClear;
      this.setState(function (prevProps) {
        return {
          editableFilters: _objectSpread(_objectSpread({}, prevProps.editableFilters), {}, (0, _defineProperty2["default"])({}, FILTER_TABS.ACTUAL, initialFilters[FILTER_TABS.ACTUAL]))
        };
      }, function () {
        _this2.handleToggleFilters(false);
        onClear();
      });
    }
  }, {
    key: "handleClearEditableFilters",
    value: function handleClearEditableFilters(event) {
      event.stopPropagation();
      var editableFilters = {};
      var initialFilters = this.props.initialFilters;
      this.setState(function (prevState) {
        return {
          editableFilters: _objectSpread(_objectSpread({}, prevState.editableFilters), {}, (0, _defineProperty2["default"])({}, FILTER_TABS.ACTUAL, _objectSpread(_objectSpread({}, initialFilters[FILTER_TABS.ACTUAL]), editableFilters)))
        };
      });
    }
  }, {
    key: "handleClearEditableFilter",
    value: function handleClearEditableFilter(name) {
      var currentEditableFilters = this.state.editableFilters;
      var editableFilters = _objectSpread({}, currentEditableFilters[FILTER_TABS.ACTUAL]);
      delete editableFilters[name];
      this.setState(function (prevState) {
        return {
          editableFilters: _objectSpread(_objectSpread({}, prevState.editableFilters), {}, (0, _defineProperty2["default"])({}, FILTER_TABS.ACTUAL, _objectSpread({}, editableFilters)))
        };
      });
    }
  }, {
    key: "handleFilterByName",
    value: function handleFilterByName(_ref) {
      var name = _ref.name,
        value = _ref.value,
        _ref$tab = _ref.tab,
        tab = _ref$tab === void 0 ? FILTER_TABS.ACTUAL : _ref$tab;
      this.setState(function (_ref2) {
        var editableFilters = _ref2.editableFilters;
        var tabFilters = editableFilters[tab];
        return {
          editableFilters: _objectSpread(_objectSpread({}, editableFilters), {}, (0, _defineProperty2["default"])({}, tab, _objectSpread(_objectSpread({}, tabFilters), {}, (0, _defineProperty2["default"])({}, name, value))))
        };
      });
    }
  }, {
    key: "handleFilter",
    value: function handleFilter(_ref3) {
      var target = _ref3.target;
      var name = target.name,
        value = target.value;
      var activeTicketsTab = this.props.activeTicketsTab;
      var editableFilters = this.state.editableFilters;
      var currentEditableFilters = editableFilters[activeTicketsTab];
      this.setState({
        editableFilters: _objectSpread(_objectSpread({}, editableFilters), {}, (0, _defineProperty2["default"])({}, activeTicketsTab, _objectSpread(_objectSpread({}, currentEditableFilters), {}, (0, _defineProperty2["default"])({}, name, value))))
      });
    }
  }, {
    key: "handleCheckoutFilter",
    value: function handleCheckoutFilter(_ref4) {
      var target = _ref4.target;
      var name = target.name,
        value = target.value;
      var activeTicketsTab = this.props.activeTicketsTab;
      var editableFilters = this.state.editableFilters;
      var currentEditableFilters = editableFilters[activeTicketsTab];
      var newValue;
      if (value) {
        var editableStatusFilters = currentEditableFilters[name] || [];
        if (editableStatusFilters.includes(value)) {
          newValue = (0, _without2["default"])(editableStatusFilters, value);
        } else {
          newValue = editableStatusFilters.concat(value);
        }
        if ((0, _isEmpty2["default"])(newValue)) {
          newValue = undefined;
        }
      }
      this.setState({
        editableFilters: _objectSpread(_objectSpread({}, editableFilters), {}, (0, _defineProperty2["default"])({}, activeTicketsTab, _objectSpread(_objectSpread({}, currentEditableFilters), {}, (0, _defineProperty2["default"])({}, name, newValue))))
      });
    }
  }, {
    key: "handleSort",
    value: function handleSort(_ref5) {
      var target = _ref5.target;
      var onSort = this.props.onSort;
      var checked = target.checked;
      onSort(checked ? 'ASC' : 'DESC');
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      event.preventDefault();
      var onFilter = this.props.onFilter;
      var editableFilters = this.state.editableFilters;
      var actualFilters = editableFilters[FILTER_TABS.ACTUAL];
      this.handleToggleFilters(false);
      onFilter(actualFilters);
    }
  }, {
    key: "handleToggleFilters",
    value: function handleToggleFilters(isOpen) {
      var _this$props2 = this.props,
        onToggle = _this$props2.onToggle,
        initialFilters = _this$props2.initialFilters,
        filters = _this$props2.filters;
      this.setState(function () {
        return {
          isOpenFilters: isOpen,
          editableFilters: (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, FILTER_TABS.ACTUAL, filters[FILTER_TABS.ACTUAL] || initialFilters[FILTER_TABS.ACTUAL]), FILTER_TABS.PLANNED, filters[FILTER_TABS.PLANNED] || initialFilters[FILTER_TABS.PLANNED])
        };
      }, function () {
        onToggle(isOpen);
      });
    }
  }, {
    key: "handleChangeTicketsTab",
    value: function handleChangeTicketsTab(tab) {
      var _this$props3 = this.props,
        activeTicketsTab = _this$props3.activeTicketsTab,
        onChangeTicketsTab = _this$props3.onChangeTicketsTab;
      if (activeTicketsTab === tab) return;
      onChangeTicketsTab(tab);
    }
  }, {
    key: "handleClickActualTab",
    value: function handleClickActualTab() {
      var _this$props4 = this.props,
        activeTicketsTab = _this$props4.activeTicketsTab,
        onFilter = _this$props4.onFilter,
        filters = _this$props4.filters;
      if (activeTicketsTab === FILTER_TABS.ACTUAL) return;
      var actualFilters = filters[FILTER_TABS.ACTUAL];
      this.handleChangeTicketsTab(FILTER_TABS.ACTUAL);
      onFilter(actualFilters);
    }
  }, {
    key: "handleClickPlannedTab",
    value: function handleClickPlannedTab() {
      var _this$props5 = this.props,
        activeTicketsTab = _this$props5.activeTicketsTab,
        onFilter = _this$props5.onFilter,
        currentManager = _this$props5.currentManager;
      if (activeTicketsTab === FILTER_TABS.PLANNED) return;
      this.handleChangeTicketsTab(FILTER_TABS.PLANNED);
      onFilter({
        statuses: ['planned'],
        managers: [currentManager.id]
      });
    }
  }, {
    key: "handleCloseFiltersModal",
    value: function handleCloseFiltersModal() {
      var _this$props6 = this.props,
        filters = _this$props6.filters,
        initialFilters = _this$props6.initialFilters;
      this.handleToggleFilters(false);
      this.setState(function (prevState) {
        return {
          editableFilters: _objectSpread(_objectSpread({}, prevState.editableFilters), {}, (0, _defineProperty2["default"])({}, FILTER_TABS.ACTUAL, filters[FILTER_TABS.ACTUAL] || initialFilters[FILTER_TABS.ACTUAL]))
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props7 = this.props,
        clients = _this$props7.clients,
        managers = _this$props7.managers,
        statuses = _this$props7.statuses,
        closedReasonStatuses = _this$props7.closedReasonStatuses,
        tags = _this$props7.tags,
        types = _this$props7.types,
        total = _this$props7.total,
        mailGroups = _this$props7.mailGroups,
        activeTicketsTab = _this$props7.activeTicketsTab,
        filters = _this$props7.filters,
        sort = _this$props7.sort,
        currentManager = _this$props7.currentManager,
        props = (0, _objectWithoutProperties2["default"])(_this$props7, _excluded);
      var _this$state = this.state,
        editableFilters = _this$state.editableFilters,
        isOpenFilters = _this$state.isOpenFilters;
      var baseProps = {
        clients: clients,
        managers: managers,
        onFilterByName: this.handleFilterByName,
        onFilter: this.handleFilter,
        onClearFilter: this.handleClearEditableFilter,
        onCheckoutFilter: this.handleCheckoutFilter,
        activeTicketsTab: activeTicketsTab,
        statuses: statuses,
        closedReasonStatuses: closedReasonStatuses,
        tags: tags,
        types: types,
        mailGroups: mailGroups
      };
      var contentProps = _objectSpread(_objectSpread({}, baseProps), {}, {
        editableFilters: editableFilters[FILTER_TABS.ACTUAL],
        currentManager: currentManager,
        onClear: this.handleClearEditableFilters,
        onClose: this.handleCloseFiltersModal,
        onSubmit: this.handleSubmit
      });
      var headerProps = _objectSpread(_objectSpread({}, baseProps), {}, {
        filters: filters,
        total: total,
        sort: sort,
        editableFilters: editableFilters,
        onClear: this.handleClear,
        onClickFilter: function onClickFilter(event) {
          event.stopPropagation();
          _this3.handleToggleFilters(true);
        },
        onSort: this.handleSort,
        onClickActual: this.handleClickActualTab,
        onClickPlanned: this.handleClickPlannedTab
      });
      return /*#__PURE__*/_react["default"].createElement(StyledTicketFilters, (0, _extends2["default"])({}, props, {
        ref: this.el
      }), /*#__PURE__*/_react["default"].createElement(StyledHeader, null, TicketFilters.getHeaderRenderer(headerProps, this.state)()), isOpenFilters && /*#__PURE__*/_react["default"].createElement(StyledFiltersModal, {
        ref: this.dropdownRef
      }, /*#__PURE__*/_react["default"].cloneElement(TicketFilters.getContentRenderer(contentProps)(), {
        tabIndex: 0
      })));
    }
  }], [{
    key: "getContentRenderer",
    value: function getContentRenderer(_ref6) {
      var editableFilters = _ref6.editableFilters,
        managers = _ref6.managers,
        onClear = _ref6.onClear,
        onClose = _ref6.onClose,
        onFilter = _ref6.onFilter,
        onClearFilter = _ref6.onClearFilter,
        onCheckoutFilter = _ref6.onCheckoutFilter,
        onFilterByName = _ref6.onFilterByName,
        onSubmit = _ref6.onSubmit,
        statuses = _ref6.statuses,
        closedReasonStatuses = _ref6.closedReasonStatuses,
        mailGroups = _ref6.mailGroups,
        tags = _ref6.tags,
        types = _ref6.types,
        currentManager = _ref6.currentManager,
        props = (0, _objectWithoutProperties2["default"])(_ref6, _excluded2);
      return function () {
        return /*#__PURE__*/_react["default"].createElement(StyledContent, (0, _extends2["default"])({}, props, {
          onSubmit: onSubmit
        }), /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
          functional: true,
          onClick: onClose,
          title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0444\u0438\u043B\u044C\u0442\u0440\u044B"
        }, /*#__PURE__*/_react["default"].createElement(_iconsReact.TicketFiltersClose, null)), /*#__PURE__*/_react["default"].createElement(StyledBody, null, /*#__PURE__*/_react["default"].createElement(StyledTitle, null, "\u0424\u0438\u043B\u044C\u0442\u0440\u044B"), /*#__PURE__*/_react["default"].createElement(StyledFilters, null, /*#__PURE__*/_react["default"].createElement(StyledFiltersColumn, null, /*#__PURE__*/_react["default"].createElement("td", {
          width: "250px"
        }, /*#__PURE__*/_react["default"].createElement(StyledTableTitle, null, "\u0414\u0430\u0442\u0430 \u0432\u044B\u043B\u0435\u0442\u0430"), /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TicketFilterByDate["default"], {
          name: FILTER_NAMES.DEPARTURE_DATE,
          onChange: onFilterByName,
          value: editableFilters[FILTER_NAMES.DEPARTURE_DATE]
        })), statuses && !(0, _isEmpty2["default"])(statuses) && /*#__PURE__*/_react["default"].createElement(StyledStatusFilter, null, /*#__PURE__*/_react["default"].createElement(StyledTableTitle, null, "\u0421\u0442\u0430\u0442\u0443\u0441\u044B \u0442\u0438\u043A\u0435\u0442\u0430"), /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TicketFilterByStatus["default"], {
          name: FILTER_NAMES.STATUSES,
          onChange: onCheckoutFilter,
          onClear: onClearFilter,
          statuses: statuses,
          value: editableFilters[FILTER_NAMES.STATUSES],
          closedReasonName: FILTER_NAMES.CLOSE_REASON_STATUSES,
          closedReasonValue: editableFilters[FILTER_NAMES.CLOSE_REASON_STATUSES],
          closedReasonStatuses: closedReasonStatuses
        }))), /*#__PURE__*/_react["default"].createElement(StyledExtraFilters, null, /*#__PURE__*/_react["default"].createElement(StyledTableTitle, null, "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u044B"), /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TicketNoOrderFilter["default"], {
          name: FILTER_NAMES.ORDERS,
          onChange: onCheckoutFilter,
          value: editableFilters[FILTER_NAMES.ORDERS]
        })))), /*#__PURE__*/_react["default"].createElement("td", null, types && !(0, _isEmpty2["default"])(types) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledTableTitle, null, "\u0422\u0438\u043F \u0442\u0438\u043A\u0435\u0442\u0430"), /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TicketFilterByType["default"], {
          name: FILTER_NAMES.TYPES,
          onChange: onFilter,
          types: types,
          value: editableFilters[FILTER_NAMES.TYPES]
        }))), mailGroups && !(0, _isEmpty2["default"])(mailGroups) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledTableTitle, null, "\u0413\u0440\u0443\u043F\u043F\u044B"), /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TicketFilterByMailGroup["default"], {
          name: FILTER_NAMES.MAIL_GROUPS,
          onChange: onFilter,
          mailGroups: mailGroups,
          value: editableFilters[FILTER_NAMES.MAIL_GROUPS],
          currentManager: currentManager
        }))), tags && !(0, _isEmpty2["default"])(tags) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledTableTitle, null, "\u0422\u0435\u0433\u0438"), /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TicketFilterByTag["default"], {
          name: FILTER_NAMES.TAGS,
          dark: true,
          onChange: onFilter,
          tags: tags,
          value: editableFilters[FILTER_NAMES.TAGS]
        }))), managers && !(0, _isEmpty2["default"])(managers) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledTableTitle, null, "\u041E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439"), /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TicketFilterByManager["default"], {
          managers: managers,
          name: FILTER_NAMES.MANAGERS,
          onChange: onFilter,
          value: editableFilters[FILTER_NAMES.MANAGERS]
        }))), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledTableTitle, null, "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043A\u0430\u0437\u0430"), /*#__PURE__*/_react["default"].createElement(StyledTableRow, null, /*#__PURE__*/_react["default"].createElement(_TicketFilterByOrderStatus["default"], {
          name: FILTER_NAMES.ORDER_STATUSES,
          onChange: onFilter,
          value: editableFilters[FILTER_NAMES.ORDER_STATUSES]
        }))))))), /*#__PURE__*/_react["default"].createElement(StyledControls, null, /*#__PURE__*/_react["default"].createElement(StyledClear, {
          primary: true,
          onClick: onClear
        }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0435 \u0444\u0438\u043B\u044C\u0442\u0440\u044B"), /*#__PURE__*/_react["default"].createElement(StyledSubmit, {
          primary: true,
          type: "submit"
        }, "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C")));
      };
    }
  }, {
    key: "getHeaderRenderer",
    value: function getHeaderRenderer(_ref7) {
      var onClear = _ref7.onClear,
        onSort = _ref7.onSort,
        sort = _ref7.sort,
        onClickFilter = _ref7.onClickFilter,
        onClickActual = _ref7.onClickActual,
        onClickPlanned = _ref7.onClickPlanned,
        activeTicketsTab = _ref7.activeTicketsTab,
        total = _ref7.total,
        filters = _ref7.filters,
        props = (0, _objectWithoutProperties2["default"])(_ref7, _excluded3);
      var actualFilters = filters[FILTER_TABS.ACTUAL];
      var isEmptyActualFilters = (0, _isEmpty2["default"])(actualFilters);
      var isValidCount = (0, _isInteger2["default"])(total) && total > 0;
      var checkedSort = sort !== 'DESC';
      return function () {
        return /*#__PURE__*/_react["default"].createElement(StyledHeader, props, /*#__PURE__*/_react["default"].createElement(StyledHeaderCategory, null, /*#__PURE__*/_react["default"].createElement(StyledTab, {
          onClick: onClickActual,
          isActive: activeTicketsTab === FILTER_TABS.ACTUAL
        }, /*#__PURE__*/_react["default"].createElement(StyledFilterButton, {
          isFiltered: !isEmptyActualFilters,
          onClick: onClickFilter,
          disabled: activeTicketsTab === FILTER_TABS.PLANNED
        }, /*#__PURE__*/_react["default"].createElement(_iconsReact.Filter, null)), isEmptyActualFilters ? 'Актуальное' : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _size2["default"])(actualFilters), ' ', (0, _userflow.pluralize)((0, _size2["default"])(actualFilters), filterPluralize), /*#__PURE__*/_react["default"].createElement(StyledClearHeaderFilters, {
          onClick: onClear,
          disabled: activeTicketsTab === FILTER_TABS.PLANNED
        }, /*#__PURE__*/_react["default"].createElement(_iconsReact.TicketFiltersClose, null)))), /*#__PURE__*/_react["default"].createElement(StyledTab, {
          isActive: activeTicketsTab === FILTER_TABS.PLANNED,
          onClick: onClickPlanned
        }, "\u0412 \u043F\u043B\u0430\u043D\u0435"), /*#__PURE__*/_react["default"].createElement(StyledSortCheckboxContainer, null, /*#__PURE__*/_react["default"].createElement(StyledSortCheckbox, {
          type: "checkbox",
          checked: checkedSort,
          onChange: onSort
        }), /*#__PURE__*/_react["default"].createElement(StyledSortBoxIcon, {
          width: 17
        }))), /*#__PURE__*/_react["default"].createElement(StyledFooter, null, isValidCount && /*#__PURE__*/_react["default"].createElement(StyledTotal, null, "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u044B ".concat((0, _userflow.formatDecimal)(total), " ").concat((0, _userflow.pluralize)(total, ticketPluralize)))));
      };
    }
  }]);
}(_react["default"].Component);
var FilterType = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, FILTER_NAMES.CLIENT, clientsValueType.isRequired), FILTER_NAMES.MAIL_GROUPS, mailGroupsValueType.isRequired), FILTER_NAMES.MANAGERS, managersValueType.isRequired), FILTER_NAMES.ORDER_STATUSES, orderStatusesValueType.isRequired), FILTER_NAMES.STATUSES, _propTypes["default"].arrayOf(Object.values(PRIORITIES).isRequired).isRequired), FILTER_NAMES.TAGS, tagsValueType.isRequired), FILTER_NAMES.TYPES, '');
var defaultClosedReasonStatuses = [{
  value: 'none',
  title: 'Без причины'
}, {
  value: 'success',
  title: 'Подобран'
}, {
  value: 'bad',
  title: 'Не подобран'
}, {
  value: 'auto',
  title: 'Тайм-аут'
}];
TicketFilters.propTypes = {
  clients: clientsType,
  filters: _propTypes["default"].shape((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, FILTER_TABS.ACTUAL, FilterType), FILTER_TABS.PLANNED, FilterType)),
  initialFilters: _propTypes["default"].shape((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, FILTER_TABS.ACTUAL, FilterType), FILTER_TABS.PLANNED, FilterType)),
  mailGroups: mailGroupsPropType,
  managers: managersType,
  onClear: _propTypes["default"].func,
  onFilter: _propTypes["default"].func,
  onToggle: _propTypes["default"].func,
  statuses: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread({}, ticketStatusPropTypes)).isRequired),
  closedReasonStatuses: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    value: _propTypes["default"].string
  })),
  tags: tagsType,
  types: typesPropType,
  total: _propTypes["default"].number,
  activeTicketsTab: _propTypes["default"].string,
  onChangeTicketsTab: _propTypes["default"].func,
  sort: _propTypes["default"].string,
  currentManager: _propTypes["default"].shape({
    id: _propTypes["default"].number,
    fullName: _propTypes["default"].string
  }).isRequired
};
TicketFilters.defaultProps = {
  clients: clientsDefault,
  filters: {},
  initialFilters: {},
  mailGroups: mailGroupsDefault,
  managers: managersDefault,
  onClear: Function.prototype,
  onFilter: Function.prototype,
  onToggle: Function.prototype,
  statuses: null,
  closedReasonStatuses: defaultClosedReasonStatuses,
  tags: tagsDefault,
  types: typesDefaultProp,
  sort: 'DESC',
  total: 0,
  activeTicketsTab: FILTER_TABS.ACTUAL,
  onChangeTicketsTab: Function.prototype
};
var StyledTicketFilters = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledTicketFilters",
  componentId: "sc-awgmys-0"
})(["position:relative;width:100%;"]);
var StyledFiltersModal = (0, _styledComponents["default"])(_Modal["default"]).withConfig({
  displayName: "TicketFilters__StyledFiltersModal",
  componentId: "sc-awgmys-1"
})(["display:flex;justify-content:center;align-items:center;"]);
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledHeader",
  componentId: "sc-awgmys-2"
})(["border-radius:4px;width:100%;"]);
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledTitle",
  componentId: "sc-awgmys-3"
})(["align-items:center;display:flex;color:#17181a;font-size:18px;font-weight:700;margin-bottom:16px;"]);
var StyledTab = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledTab",
  componentId: "sc-awgmys-4"
})(["align-items:center;justify-content:center;display:flex;width:100%;cursor:pointer;white-space:nowrap;color:#17181a;font-size:16px;line-height:20px;font-weight:", ";background-color:", ";padding:5px 15px;border-radius:16px;"], function (_ref8) {
  var isActive = _ref8.isActive;
  return isActive ? 'bold' : 'normal';
}, function (_ref9) {
  var isActive = _ref9.isActive;
  return isActive ? 'white' : 'transparent';
});
var StyledFilterButton = _styledComponents["default"].button.withConfig({
  displayName: "TicketFilters__StyledFilterButton",
  componentId: "sc-awgmys-5"
})(["display:flex;margin-right:4px;border:none;outline:none;background:transparent;cursor:pointer;svg{height:16px;width:16px;.border{stroke:", ";}.filled{fill:", ";}}:disabled{svg{.border{stroke:#4d4d4d;}.filled{fill:#4d4d4d;}}}"], function (_ref10) {
  var isFiltered = _ref10.isFiltered;
  return isFiltered ? '#d0021b' : '#007aff';
}, function (_ref11) {
  var isFiltered = _ref11.isFiltered;
  return isFiltered ? '#d0021b' : 'transparent';
});
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketFilters__StyledButton",
  componentId: "sc-awgmys-6"
})(["width:178px;outline:none;border:none;"]);
var StyledClear = _styledComponents["default"].button.withConfig({
  displayName: "TicketFilters__StyledClear",
  componentId: "sc-awgmys-7"
})(["font-size:14px;cursor:pointer;color:#d0021b;background-color:transparent;border:none;outline:none;"]);
var StyledHeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledHeaderContainer",
  componentId: "sc-awgmys-8"
})(["display:flex;flex-direction:row;padding:10px;justify-content:space-between;"]);
var StyledClearHeaderFilters = _styledComponents["default"].button.withConfig({
  displayName: "TicketFilters__StyledClearHeaderFilters",
  componentId: "sc-awgmys-9"
})(["display:flex;margin-right:4px;border:none;outline:none;background:transparent;cursor:pointer;svg{width:8px;height:8px;margin-top:3px;margin-left:5px;}"]);
var StyledHeaderCategory = (0, _styledComponents["default"])(StyledHeaderContainer).withConfig({
  displayName: "TicketFilters__StyledHeaderCategory",
  componentId: "sc-awgmys-10"
})(["min-height:37px;"]);
var StyledFooter = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledFooter",
  componentId: "sc-awgmys-11"
})(["display:flex;flex-direction:row;justify-content:center;"]);
var StyledTotal = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledTotal",
  componentId: "sc-awgmys-12"
})(["color:#93969b;font-size:12px;line-height:16px;font-weight:normal;"]);
var StyledBody = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledBody",
  componentId: "sc-awgmys-13"
})(["min-height:150px;"]);
var StyledControls = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledControls",
  componentId: "sc-awgmys-14"
})(["display:flex;align-items:center;justify-content:space-between;margin-top:16px;"]);
var StyledContent = _styledComponents["default"].form.withConfig({
  displayName: "TicketFilters__StyledContent",
  componentId: "sc-awgmys-15"
})(["background-color:#fff;border-radius:4px;display:flex;flex-direction:column;padding:16px;z-index:2;width:750px;position:relative;"]);
var StyledCloseButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketFilters__StyledCloseButton",
  componentId: "sc-awgmys-16"
})(["position:absolute;top:16px;right:16px;svg{height:12px;width:12px;}"]);
var StyledFiltersColumn = _styledComponents["default"].table.withConfig({
  displayName: "TicketFilters__StyledFiltersColumn",
  componentId: "sc-awgmys-17"
})(["border-collapse:separate;table-layout:fixed;width:100%;color:#4d4d4d;font-size:14px;td{padding-right:16px;&:last-of-type{padding-right:0;}}"]);
var StyledTableRow = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledTableRow",
  componentId: "sc-awgmys-18"
})(["display:inline-block;width:100%;margin-bottom:16px;:last-of-type{margin-bottom:0;}"]);
var StyledTableTitle = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledTableTitle",
  componentId: "sc-awgmys-19"
})(["display:inline-block;width:100%;font-weight:700;margin-bottom:8px;"]);
var StyledFilters = _styledComponents["default"].div.withConfig({
  displayName: "TicketFilters__StyledFilters",
  componentId: "sc-awgmys-20"
})(["display:flex;"]);
var StyledStatusFilter = (0, _styledComponents["default"])(StyledTableRow).withConfig({
  displayName: "TicketFilters__StyledStatusFilter",
  componentId: "sc-awgmys-21"
})(["td:last-of-type{color:#17181a;font-size:12px;}li + li{margin-top:10px;}", "{margin-right:4px;}"], StyledCheckboxWrapper);
var StyledExtraFilters = (0, _styledComponents["default"])(StyledTableRow).withConfig({
  displayName: "TicketFilters__StyledExtraFilters",
  componentId: "sc-awgmys-22"
})(["td:last-of-type{color:#17181a;font-size:12px;}li + li{margin-top:10px;}", "{margin-right:4px;}"], StyledCheckboxWrapper);
var StyledSubmit = (0, _styledComponents["default"])(StyledButton).withConfig({
  displayName: "TicketFilters__StyledSubmit",
  componentId: "sc-awgmys-23"
})(["height:40px;width:100px;background:#007aff;color:white;font-weight:bold;border-radius:4px;padding:11px 12px 13px;:hover{background:#007aff;}"]);
var StyledSortBoxIcon = (0, _styledComponents["default"])(_iconsReact.SortBox).withConfig({
  displayName: "TicketFilters__StyledSortBoxIcon",
  componentId: "sc-awgmys-24"
})([""]);
var StyledSortCheckbox = _styledComponents["default"].input.withConfig({
  displayName: "TicketFilters__StyledSortCheckbox",
  componentId: "sc-awgmys-25"
})(["background:transparent;position:absolute;opacity:0;cursor:pointer;height:0;width:0;"]);
var StyledSortCheckboxContainer = _styledComponents["default"].label.withConfig({
  displayName: "TicketFilters__StyledSortCheckboxContainer",
  componentId: "sc-awgmys-26"
})(["display:flex;align-items:center;position:relative;padding-left:10px;cursor:pointer;user-select:none;& > ", ":checked ~ ", "{position:relative;top:2px;transform:rotateX(180deg);}"], StyledSortCheckbox, StyledSortBoxIcon);
TicketFilters.FILTER_NAMES = FILTER_NAMES;
TicketFilters.ORDER_STATUSES = ORDER_STATUSES;
TicketFilters.STATUS_PRIORITIES = PRIORITIES;
TicketFilters.FILTER_TABS = FILTER_TABS;
var _default = exports["default"] = TicketFilters;